
namespace Matrix.Dashboards {

    @Serenity.Decorators.registerClass()
    export class WidgetCatalogDialog extends SiteEntityDialog<WidgetCatalogRow, any> {
        protected getFormKey() { return WidgetCatalogForm.formKey; }
        protected getIdProperty() { return WidgetCatalogRow.idProperty; }
        protected getLocalTextPrefix() { return WidgetCatalogRow.localTextPrefix; }
        protected getNameProperty() { return WidgetCatalogRow.nameProperty; }
        protected getService() { return WidgetCatalogService.baseUrl; }
        protected getDeletePermission() { return WidgetCatalogRow.deletePermission; }
        protected getInsertPermission() { return WidgetCatalogRow.insertPermission; }
        protected getUpdatePermission() { return WidgetCatalogRow.updatePermission; }

        protected form = new WidgetCatalogForm(this.idPrefix);

        protected useViewMode() {
            return false;
        }

        private widgetEditor: WidgetEditor;

        constructor(opt?: any) {
            super(opt);

            this.widgetEditor = new WidgetEditor($(`<div id="${this.idPrefix}_DashboardContainer">`).insertAfter(this.form.Name.element.closest('.category')), {});

            this.form.WidgetType.changeSelect2(() => {
                var val = this.form.WidgetType.value;
                if (!val)
                    this.setWidgetEditorValue(null, {});
                else {
                    Q.getLookupAsync<WidgetTypeItem>("Dashboards.WidgetType").then(lookup => {
                        var widgetType = lookup.itemById[val];
                        if (!widgetType)
                            this.setWidgetEditorValue(val, {});
                        else
                            this.setWidgetEditorValue(val, {
                                LayoutW: widgetType.Cols,
                                LayoutH: widgetType.Rows
                            });
                    });
                }
            });
        }

        protected getSaveEntity() {
            var entity = super.getSaveEntity();
            entity.Properties = {};
            var item = (this.widgetEditor.value || [])[0] || {};
            entity.Properties.WidgetOptions = item.WidgetOptions;
            entity.Properties.LayoutW = item.LayoutW;
            entity.Properties.LayoutH = item.LayoutH;

            return entity;
        }

        protected loadEntity(entity: DashboardRow) {

            super.loadEntity(entity);

            this.setWidgetEditorValue(this.entity.WidgetType, this.entity.Properties);
        }

        protected setWidgetEditorValue(widgetType: string, properties: WidgetCatalogData) {
            if (!widgetType)
                this.widgetEditor.value = [];
            else {
                var props = (properties || {});
                this.widgetEditor.value = [{
                    LayoutX: 0,
                    LayoutY: 0,
                    LayoutW: props.LayoutW || defaultWidgetCols,
                    LayoutH: props.LayoutH || defaultWidgetRows,
                    WidgetType: widgetType,
                    WidgetOptions: props.WidgetOptions || {}
                }];
            }

        }
    }
}